/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommandResource } from '@alfa-client/command-shared';
import { createEmptyStateResource, StateResource } from '@common/tech-shared';
import { UserProfileResource, UserProfileService } from '@alfa-client/user-profile-shared';
import { Component, inject, Input, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';
import { UserProfileSearchResultsComponent } from './user-profile-search-results/user-profile-search-results.component';

@Component({
  selector: 'alfa-user-profile-search-results-container',
  standalone: false,
  templateUrl: './user-profile-search-results-container.component.html',
})
export class UserProfileSearchResultsContainerComponent {
  private readonly service = inject(UserProfileService);

  @Input() searchResults: StateResource<UserProfileResource>[];
  @Input() showUnassigned: boolean;

  @ViewChild(UserProfileSearchResultsComponent) resultsComp: UserProfileSearchResultsComponent;

  command$: Observable<StateResource<CommandResource>> = of(createEmptyStateResource<CommandResource>());

  public assign(userProfile: UserProfileResource): void {
    this.command$ = this.service.assign(userProfile);
  }

  public unassign(): void {
    this.command$ = this.service.unassign();
  }
}
